module.exports = __webpack_public_path__ + "static/media/upload.e86a473b.svg";